// The privacy card (Settings and the start page) and the trust strip (start page, Study Hall,
// /privacy). Every line here must stay true of the code; /privacy explains each one, and the
// anchors point at its paragraphs. No em dashes, study words only (test/privacy.test.mjs).
import { BROWSING_LOGS_CLEAN } from "./hall-rollout.js";

export const CARD_TITLE = "Your privacy";
export const CARD_POINTS = [
	"Your history stays in this browser unless you choose Back up. Other students can't see the sites you visit.",
	"Logins for other sites stay in this browser. They are never saved to your Re:Vault account.",
	"Study Hall messages are deleted after 30 days, unless they are part of a report or a moderation case.",
];
export const CARD_LINK = "Read how it works";
export const PRIVACY_URL = "/privacy";

// [text, anchor on /privacy]
export function trustItems(clean = BROWSING_LOGS_CLEAN) {
	return [
		["No stranger DMs", "no-dms"],
		clean ? ["No browsing tracking", "not-tracked"] : ["Site logins stay on your device", "your-stuff"],
		["Real moderators", "moderators"],
	];
}
export const TRUST_LABEL = "How Re:Vault keeps you safe";

// Builds the strip as DOM (no HTML strings). open(url) handles a click when given; otherwise the
// links are plain /privacy#... links.
export function trustStrip(doc, cls, open) {
	const p = doc.createElement("p");
	p.className = cls;
	p.setAttribute("aria-label", TRUST_LABEL);
	trustItems().forEach(([text, id], i) => {
		if (i) p.append(doc.createTextNode(" · "));
		const a = doc.createElement("a");
		a.href = PRIVACY_URL + "#" + id;
		a.textContent = text;
		if (open) a.addEventListener("click", (e) => { e.preventDefault(); open(a.getAttribute("href")); });
		p.append(a);
	});
	return p;
}

// The card as DOM. close: optional dismiss handler (the start page); open: as above.
export function privacyCard(doc, cls, { open, close } = {}) {
	const box = doc.createElement("div");
	box.className = cls;
	const head = doc.createElement("div");
	head.className = cls + "-head";
	const h = doc.createElement("h3");
	h.className = cls + "-title";
	h.textContent = CARD_TITLE;
	head.append(h);
	if (close) {
		const x = doc.createElement("button");
		x.type = "button";
		x.className = cls + "-x";
		x.setAttribute("aria-label", "Got it, hide this");
		x.title = "Got it";
		x.textContent = "Got it";
		x.addEventListener("click", close);
		head.append(x);
	}
	const ul = doc.createElement("ul");
	ul.className = cls + "-list";
	for (const t of CARD_POINTS) { const li = doc.createElement("li"); li.textContent = t; ul.append(li); }
	const a = doc.createElement("a");
	a.className = cls + "-link";
	a.href = PRIVACY_URL;
	a.textContent = CARD_LINK;
	if (open) a.addEventListener("click", (e) => { e.preventDefault(); open(PRIVACY_URL); });
	box.append(head, ul, a);
	return box;
}
